import ApiClient from '@/api/ApiClient';

import type {
  CaseConfiguration,
} from '../models';

export class CaseconfigurationsClient {
  apiClient: ApiClient;

  constructor(apiClient?: ApiClient) {
    this.apiClient = apiClient || ApiClient.instance;
  }

  getCaseConfigurations(): Promise<CaseConfiguration[]> {
    return this.apiClient.get({
      path: '/api/caseconfigurations',
    });
  }

  addCaseConfiguration(request: { body?: Record<string, unknown>; } = {}): Promise<void> {
    const { body } = request;
    return this.apiClient.post({
      path: '/api/caseconfigurations',
      body,
    });
  }

  getCaseConfiguration(request: { id: string; }): Promise<CaseConfiguration> {
    const { id } = request;
    return this.apiClient.get({
      path: `/api/caseconfigurations/${id}`,
    });
  }

  updateCaseConfiguration(request: { id: string; body?: CaseConfiguration; }): Promise<void> {
    const { id, body } = request;
    return this.apiClient.put({
      path: `/api/caseconfigurations/${id}`,
      body,
    });
  }

  deleteConfiguration(request: { id: string; }): Promise<void> {
    const { id } = request;
    return this.apiClient.del({
      path: `/api/caseconfigurations/${id}`,
    });
  }
}

export default CaseconfigurationsClient;
